/** What each AI Score metric measures (generation_quality v2). */
const SCORE_METRIC_TOOLTIP = {
  contextual_grounding:
    'How well the output is supported by its grounding source: the context messages, or tool results and prior assistant turns when no explicit context is sent. A blend of semantic similarity and entailment. Higher is better.',
  rule_adherence:
    'Share of mechanical system-message rules the output passed (format, length, required phrases). Higher is better.',
  logical_contradiction:
    'Estimated probability the output contradicts its grounding source or reverses key facts. Lower is better.',
  trajectory_confabulation:
    'How closely this output follows the usual direction for this LLM node compared to its historical baseline. Higher is better.',
  factual_retention:
    'Share of the hard facts the output states (IDs, numbers, dates, URLs) that are actually supported by its context or the question. Catches invented facts; a correct answer is not penalised for leaving out details it was not asked about. Higher is better.',
  semantic_echo:
    'How similar the output is to the input: flags near-verbatim copying. Lower is better.',
  refusal_overreach:
    'How strongly the model refused or deflected when it should have answered. Lower is better.',
};

export function getScoreMetricTooltip(pattern) {
  if (!pattern) return undefined;
  return SCORE_METRIC_TOOLTIP[pattern];
}
